import { ref } from 'vue'
import type { ChatMessage, ChatScope } from '@/utils/chatDb'
import { getAppParams } from '@/stores/app'

// 模块级响应式单例：当前会话的消息列表与状态。持久化由 chatDb(IDB) 负责，
// 这里只持内存态供组件响应式引用；跨组件共享（VoiceRecorder 发送 → 列表刷新）靠同一 ref。
export const messages = ref<ChatMessage[]>([])
export const isSyncing = ref(false)
export const isLoadingMore = ref(false)
export const hasMore = ref(true)
export const currentSubUserId = ref<number | null>(null)
// 正在转写的消息ID（单条或批量），驱动语音气泡旁转圈动画与 Popover 按钮状态
export const convertingMsgId = ref<string | null>(null)

// ============ 同步游标（localStorage，对齐 RN AsyncStorage 的 sync_cursor key） ============

/** 账号在发起请求时固定，不能在异步响应回来后重新读取当前账号。 */
export function getChatScope(subUserId: number): ChatScope | null {
  const userId = getAppParams().user_info?.userId
  if (userId == null || String(userId) === '' || !Number.isSafeInteger(subUserId) || subUserId <= 0) return null
  return { userId: String(userId), subUserId }
}

function getSyncCursorKey(scope: ChatScope): string {
  return `chat_sync_cursor_${scope.userId}_${scope.subUserId}`
}

export function getSyncCursor(scope: ChatScope): string | null {
  return localStorage.getItem(getSyncCursorKey(scope))
}

export function setSyncCursor(scope: ChatScope, messageId: string): void {
  localStorage.setItem(getSyncCursorKey(scope), messageId)
}
